import useIsRegistrationDisabled from "@casino/client/hooks/useIsRegistrationDisabled";
import useGameContext from "@casino/legacy/client/components/Game/context/Game/useGameContext";
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import useRedirect from "@casino/legacy/client/hooks/router/useRedirect";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useCurrentUser from "@casino/legacy/client/hooks/user/useCurrentUser";
import useSite from "@casino/legacy/client/hooks/useSite";
import useParseExternalHref from "@casino/legacy/client/shared/NextLink/useNextLink/useParseExternalHref";
import useAccountPopoverStore from "@casino/legacy/client/store/useAccountPopoverStore";
import { useCallback } from "react";

const useFunModeToggle = () => {
  const { showPopover } = useAccountPopoverStore();
  const { user } = useCurrentUser();
  const { isBridgeSite } = useSite();
  const { replace, asPath } = useRouter();
  const { isFunMode, setFunMode } = useGameContext();
  const leftLabel = useTranslation("game.fun_mode");
  const rightLabel = useTranslation("game.real_mode");
  const { parseExternalHref } = useParseExternalHref();
  const { redirect } = useRedirect();
  const isRegistrationDisabled = useIsRegistrationDisabled();

  const handleChange = useCallback(
    (checked: boolean) => {
      if (!user) {
        if (isRegistrationDisabled) {
          return;
        }
        if (isBridgeSite) {
          replace(`${asPath}?c=home`);
          redirect(parseExternalHref("/register"));
          return;
        }
        showPopover("signup");
        setFunMode(checked);
        setTimeout(() => {
          setFunMode(!checked);
        }, 0);
        return;
      }
      setFunMode(checked);
    },
    [
      user,
      setFunMode,
      showPopover,
      isBridgeSite,
      isRegistrationDisabled,
      parseExternalHref,
      replace,
      redirect,
      asPath,
    ],
  );

  return { isFunMode, handleChange, leftLabel, rightLabel };
};

export default useFunModeToggle;
